/**
 * Internal dependencies
 */
import breakpoints from './breakpoint-values';
/**
 * @param {keyof breakpoints} point
 * @return {string} Media query declaration.
 */

export var breakpoint = function breakpoint(point) {
  return "@media (min-width: ".concat(breakpoints[point], ")");
};
//# sourceMappingURL=breakpoint.js.map